import { createSelector, createFeatureSelector } from '@ngrx/store';
import { AuthState } from './auth.state';

export const authSelector = createFeatureSelector<AuthState>('auth');

export const isAuthenticated = createSelector(authSelector, (state: AuthState) => state.user !== null);
export const getUser = createSelector(authSelector, (state: AuthState) => state.user);
export const getUserPhoto = createSelector(authSelector, (state: AuthState) => state.userPhotoUrl);
